// extracted by mini-css-extract-plugin
module.exports = {"container":"container--vVAPjvWc","statusTagDone":"statusTagDone--_eDk3mgB","statusTagPending":"statusTagPending--LfuqNVVZ"};